import { render, staticRenderFns } from "./groupDbData.vue?vue&type=template&id=1d79d4fb&scoped=true"
import script from "./groupDbData.vue?vue&type=script&lang=js"
export * from "./groupDbData.vue?vue&type=script&lang=js"
import style0 from "./groupDbData.vue?vue&type=style&index=0&id=1d79d4fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79d4fb",
  null
  
)

export default component.exports